/* eslint-disable prettier/prettier */

import { attackDiceMap, MonsterEntity } from "../../../constants/Monster";
import { NPCEntity } from "../../../constants/npc/NPC";
import { AuthState } from "../../../context/AuthState";
import { addEvenlySpacedText, addGroupedText, addImage, addText, initializePdf, labelValues, newPage, TEXT_SETTINGS } from "./InitializePdf";
import { documentAttackDetails } from "./MonsterPdf";

export async function uploadNPCPdf(
    npcEntity: NPCEntity,
    monsterEntity: MonsterEntity,
    authState: AuthState,
    s3Key: string,
): Promise<void> {
    console.log("Start npc pdf");
    const doc = initializePdf();
    let height = 50;
    height = addText(npcEntity.name, TEXT_SETTINGS.Title, doc, height);
    height = addText(`${npcEntity.archetype} - ${npcEntity.template}`, TEXT_SETTINGS.Center, doc, height);
    if (npcEntity.ideal) {
        height = addText(`Ideal: ${npcEntity.ideal}`, TEXT_SETTINGS.Center, doc, height);
    }
    if (npcEntity.previewS3Key !== "") {
        const presignedUrl = await authState.getPresignedUrlWithKey(npcEntity.previewS3Key);
        await addImage(presignedUrl, doc, height);
        height += 320
    } else {
        height += 20
    }
    console.log("Title npc pdf");
    
    if (npcEntity.description) {
        const descriptionTexts = [
            { text: "Description", textSetting: TEXT_SETTINGS.Subtitle },
            { text: npcEntity.description, textSetting: TEXT_SETTINGS.Standard },
        ];
        height = addGroupedText(descriptionTexts, doc, height);
    }
    console.log("Description");

    if (npcEntity.secret1 !== "") {
        const secretTexts = [
        { text: "Secrets", textSetting: TEXT_SETTINGS.Subtitle },
        { text: `${npcEntity.secret1}`, textSetting: TEXT_SETTINGS.Standard },
        ]
        if (npcEntity.secret2 !== "") {
            secretTexts.push(
            { text: `${npcEntity.secret2}`, textSetting: TEXT_SETTINGS.Standard },
            )
        }
        if (npcEntity.secret3 !== "") {
            secretTexts.push(
            { text: `${npcEntity.secret3}`, textSetting: TEXT_SETTINGS.Standard },
            )
        }
        height = addGroupedText(secretTexts, doc, height);
        height += 20;
    }
    console.log("Secrets");

    if (monsterEntity.name) {
        height = addText(monsterEntity.name, TEXT_SETTINGS.CenterBold, doc, height);
    }
    console.log("Monster name");

    const statLabels = ["Health", "Armor", "Speed", "Actions"];
    const statValues = [
        monsterEntity.health,
        monsterEntity.armor,
        monsterEntity.speed,
        monsterEntity.actions,
    ];
    console.log("Monster stats");
    if (monsterEntity.reactionDescription1 && monsterEntity.reactionDescription1 !== "" && monsterEntity.reactions !== 0) {
        statLabels.push("Reactions");
        statValues.push(monsterEntity.reactions);
    }
    console.log("Monster reactiosn");
    const statTexts = labelValues(statLabels, statValues);
    height = addEvenlySpacedText(statTexts, TEXT_SETTINGS.Standard, doc, height);
    height += 10;
    const abilityLabels = ["STR", "AGI", "INT", "WIS", "CHA"];
    const abilityValues = [
        monsterEntity.str,
        monsterEntity.dex,
        monsterEntity.int,
        monsterEntity.wis,
        monsterEntity.cha,
    ];
    const abilityTexts = labelValues(abilityLabels, abilityValues);
    height = addEvenlySpacedText(abilityTexts, TEXT_SETTINGS.Standard, doc, height);
    height += 20;
    console.log("Monster abilities")

    console.log("Attack Target");
    console.log(monsterEntity);
    console.log("Damage Type");
    console.log(monsterEntity);
    let attackText = "";
    if (monsterEntity.attackTarget.includes("Spell")) {
        attackText += `${monsterEntity.attackTarget}`;
    } else {
        attackText += "Attack";
    }
    if (monsterEntity.damageType !== "Weapon") {
        attackText += ` (${monsterEntity.damageType})`
    }
    console.log("Monster target for attack")
    attackText += ":"
    const attackDiceText = attackDiceMap.get(monsterEntity.attackDice)?.replaceAll("+", " + ");
    attackText += ` ${attackDiceText} + ${monsterEntity.attackBonus}, ${monsterEntity.attackRange}ft range`;
    if (monsterEntity.attackRadius > 0) {
        attackText += `, ${monsterEntity.attackRadius}ft radius!`;
    } else {
        attackText += "."
    }
    height = addText(attackText, TEXT_SETTINGS.Standard, doc, height);
    console.log("Attack finished")

    if (npcEntity.linkToMonster) {
        height = documentAttackDetails(doc, monsterEntity, height);
    }

    await authState.uploadFile(s3Key, doc.output("blob"));
}